// 랜딩 텍스트 디자인 엔진 (배너생성기 자산 이식) — 랜딩 렌더와 봇 편집기가 공유.
// 글꼴/명명 그라데이션/입체효과/외곽선/자간을 MUI sx 로 변환.

// 글꼴 key → CSS font-family
export const TEXT_FONTS = {
  serif: "'Noto Serif KR', serif", sans: "'Pretendard','Noto Sans KR',sans-serif", orbitron: "'Orbitron',system-ui,sans-serif",
  blackhan: "'Black Han Sans',sans-serif", dohyeon: "'Do Hyeon',sans-serif", gugi: "'Gugi',system-ui",
  jua: "'Jua',sans-serif", dongle: "'Dongle',sans-serif", gaegu: "'Gaegu',cursive",
  nanumpen: "'Nanum Pen Script',cursive", nanumbrush: "'Nanum Brush Script',cursive",
  hahmlet: "'Hahmlet',serif", songmyung: "'Song Myung',serif", gowunbatang: "'Gowun Batang',serif",
  gowundodum: "'Gowun Dodum',sans-serif", diphylleia: "'Diphylleia',serif", nanumgothic: "'Nanum Gothic',sans-serif",
  gothica1: "'Gothic A1',sans-serif", sunflower: "'Sunflower',sans-serif", gasoek: "'Gasoek One',sans-serif",
  bagel: "'Bagel Fat One',system-ui", moirai: "'Moirai One',system-ui", bwpicture: "'Black And White Picture',system-ui",
  yeonsung: "'Yeon Sung',system-ui", kirang: "'Kirang Haerang',system-ui",
};
// Google Fonts 패밀리 (동적 로드용). serif/sans/orbitron 은 기본 로드라 제외.
export const GF_FAMILIES = {
  blackhan: 'Black+Han+Sans', dohyeon: 'Do+Hyeon', gugi: 'Gugi', jua: 'Jua', dongle: 'Dongle:wght@300;400;700',
  gaegu: 'Gaegu:wght@300;400;700', nanumpen: 'Nanum+Pen+Script', nanumbrush: 'Nanum+Brush+Script',
  hahmlet: 'Hahmlet:wght@300;400;700;900', songmyung: 'Song+Myung', gowunbatang: 'Gowun+Batang:wght@400;700',
  gowundodum: 'Gowun+Dodum', diphylleia: 'Diphylleia', nanumgothic: 'Nanum+Gothic:wght@400;700;800',
  gothica1: 'Gothic+A1:wght@300;400;700;900', sunflower: 'Sunflower:wght@300;500;700', gasoek: 'Gasoek+One',
  bagel: 'Bagel+Fat+One', moirai: 'Moirai+One', bwpicture: 'Black+And+White+Picture', yeonsung: 'Yeon+Sung',
  kirang: 'Kirang+Haerang',
};
// 편집기 드롭다운용 (key, label)
export const FONT_OPTS = [
  ['serif', '명조 (Noto Serif)'], ['sans', '고딕 (Pretendard)'], ['orbitron', '영문 테크 (Orbitron)'],
  ['blackhan', '블랙한산스 (굵게)'], ['gasoek', '가속원 (임팩트)'], ['bagel', '베이글팻 (통통)'],
  ['moirai', '모이라이 (트렌디)'], ['gugi', '구기 (디스플레이)'], ['dohyeon', '도현 (라운드)'],
  ['jua', '주아 (라운드)'], ['yeonsung', '연성 (디스플레이)'], ['kirang', '기랑해랑 (레트로)'],
  ['bwpicture', '흑백사진 (개성)'], ['dongle', '동글 (둥근)'], ['gaegu', '개구 (손글씨)'],
  ['nanumpen', '나눔펜 (손글씨)'], ['nanumbrush', '나눔붓 (붓글씨)'], ['sunflower', '해바라기'],
  ['gowundodum', '고운돋움 (부드러운)'], ['nanumgothic', '나눔고딕'], ['gothica1', '고딕A1'],
  ['hahmlet', '함렛 (모던세리프)'], ['songmyung', '송명 (클래식명조)'], ['gowunbatang', '고운바탕 (명조)'],
  ['diphylleia', '디필레이아 (우아)'],
];

// 명명 그라데이션 (배너생성기 tgrad-*)
export const TGRAD = {
  gold: 'linear-gradient(180deg,#fff8de 0%,#ffe585 38%,#ffc62e 68%,#f0a81e 100%)',
  chrome: 'linear-gradient(180deg,#ffffff 0%,#dce8f2 38%,#a8bccf 58%,#ffffff 100%)',
  silver: 'linear-gradient(180deg,#ffffff 0%,#e6edf4 38%,#a8b6c6 60%,#f2f6fa 100%)',
  bronze: 'linear-gradient(180deg,#ffe3c0 0%,#cd7f32 50%,#7a4a1e 100%)',
  neon: 'linear-gradient(180deg,#a8fff0,#36ffe0 50%,#00b3ff)',
  fire: 'linear-gradient(180deg,#fff0a8,#ff8a1f 45%,#ff2d2d)',
  lava: 'linear-gradient(180deg,#ffd86b 0%,#ff5a1f 45%,#c41414 100%)',
  ice: 'linear-gradient(180deg,#ffffff,#bfe9ff 50%,#5aa0e6)',
  ocean: 'linear-gradient(180deg,#cdf2ff 0%,#36b4ff 50%,#0a66cc 100%)',
  emerald: 'linear-gradient(180deg,#d6ffe9 0%,#34d399 50%,#0a7a52 100%)',
  mint: 'linear-gradient(180deg,#eafff7 0%,#7cf7d4 55%,#23b58f 100%)',
  rosegold: 'linear-gradient(180deg,#ffe9e3 0%,#f0b8a0 45%,#c8806a 100%)',
  candy: 'linear-gradient(180deg,#fff0f8 0%,#ff7ec2 50%,#ff3aa0 100%)',
  purple: 'linear-gradient(180deg,#efd9ff 0%,#a855f7 50%,#6d28d9 100%)',
  sunset: 'linear-gradient(180deg,#fff0c8 0%,#ff8a5c 45%,#ff4a8c 100%)',
  holo: 'linear-gradient(100deg,#ff9ad2 0%,#a0e9ff 25%,#b6ffd0 50%,#fff0a0 75%,#c8a0ff 100%)',
  rainbow: 'linear-gradient(90deg,#ff6a6a,#ffd24a 25%,#5fe08a 50%,#36c6ff 75%,#b86aff)',
};
export const GRAD_OPTS = [
  ['theme', '테마색(기본)'], ['custom', '직접 지정'], ['solid', '단색'], ['white', '화이트'],
  ['gold', '골드'], ['chrome', '크롬'], ['silver', '실버'], ['bronze', '브론즈'], ['neon', '네온'],
  ['fire', '파이어'], ['lava', '라바'], ['ice', '아이스'], ['ocean', '오션'], ['emerald', '에메랄드'],
  ['mint', '민트'], ['rosegold', '로즈골드'], ['candy', '캔디'], ['purple', '퍼플'], ['sunset', '선셋'],
  ['holo', '홀로그램'], ['rainbow', '레인보우'],
];

// 입체/발광 효과 (배너생성기 ttex-*) — sh = 그림자/발광 색
export const ttexFilter = (name, sh) => ({
  '3d': `drop-shadow(1px 1px 0 ${sh}) drop-shadow(2px 2px 0 ${sh}) drop-shadow(3px 3px 0 ${sh}) drop-shadow(0 5px 5px rgba(0,0,0,.5))`,
  shadow: `drop-shadow(3px 4px 0 ${sh}) drop-shadow(0 6px 10px rgba(0,0,0,.45))`,
  longshadow: `drop-shadow(2px 2px 0 ${sh}) drop-shadow(4px 4px 0 ${sh}) drop-shadow(6px 6px 0 ${sh}) drop-shadow(8px 8px 0 ${sh}) drop-shadow(10px 10px 0 ${sh}) drop-shadow(12px 13px 6px rgba(0,0,0,.5))`,
  hard: `drop-shadow(5px 5px 0 ${sh})`,
  retro: `drop-shadow(3px 3px 0 ${sh}) drop-shadow(6px 6px 0 rgba(0,0,0,.35))`,
  lift: 'drop-shadow(0 12px 13px rgba(0,0,0,.55))',
  neon: `drop-shadow(0 0 5px ${sh}) drop-shadow(0 0 14px ${sh}) drop-shadow(0 0 26px ${sh})`,
  glow: `drop-shadow(0 0 8px ${sh}) drop-shadow(0 0 20px ${sh})`,
  metal: 'drop-shadow(0 2px 3px rgba(0,0,0,.55))',
  emboss: `drop-shadow(-1px -1px 0 rgba(255,255,255,.5)) drop-shadow(1px 1px 0 ${sh})`,
  halo: 'drop-shadow(2px 0 0 #fff) drop-shadow(-2px 0 0 #fff) drop-shadow(0 2px 0 #fff) drop-shadow(0 -2px 0 #fff) drop-shadow(2px 2px 0 #fff) drop-shadow(-2px -2px 0 #fff) drop-shadow(2px -2px 0 #fff) drop-shadow(-2px 2px 0 #fff) drop-shadow(2px 4px 4px rgba(0,0,0,.5))',
}[name] || '');
export const EFFECT_OPTS = [
  ['none', '없음'], ['3d', '3D 입체'], ['shadow', '그림자'], ['longshadow', '롱섀도'], ['hard', '각진 그림자'],
  ['retro', '레트로'], ['lift', '떠있는'], ['neon', '네온'], ['glow', '글로우'], ['metal', '메탈'], ['emboss', '엠보싱'], ['halo', '흰 테두리'],
];

// 원클릭 텍스트 프리셋 (그라데이션+효과+외곽선 조합)
export const TEXT_PRESETS = [
  ['골드 3D', { gradient: 'gold', effect: '3d', outline: true, outlineColor: '#3a1d00', effectColor: '#3a1d00' }],
  ['크롬 3D', { gradient: 'chrome', effect: '3d', outline: true, outlineColor: '#0a1326', effectColor: '#0a1326' }],
  ['실버 메탈', { gradient: 'silver', effect: 'metal', outline: true, outlineColor: '#1a2230', effectColor: '#1a2230' }],
  ['네온 글로우', { gradient: 'neon', effect: 'neon', outline: false, effectColor: '#36ffe0' }],
  ['파이어', { gradient: 'fire', effect: '3d', outline: true, outlineColor: '#3a0a0a', effectColor: '#3a0a0a' }],
  ['아이스', { gradient: 'ice', effect: 'shadow', outline: true, outlineColor: '#0a2740', effectColor: '#0a2740' }],
  ['오션', { gradient: 'ocean', effect: '3d', outline: true, outlineColor: '#04203a', effectColor: '#04203a' }],
  ['에메랄드', { gradient: 'emerald', effect: '3d', outline: true, outlineColor: '#03251a', effectColor: '#03251a' }],
  ['민트 글로우', { gradient: 'mint', effect: 'glow', outline: false, effectColor: '#7CF7D4' }],
  ['로즈골드', { gradient: 'rosegold', effect: '3d', outline: true, outlineColor: '#3a1020', effectColor: '#3a1020' }],
  ['퍼플 글로우', { gradient: 'purple', effect: 'glow', outline: false, effectColor: '#a855f7' }],
  ['선셋', { gradient: 'sunset', effect: '3d', outline: true, outlineColor: '#2a0a2a', effectColor: '#2a0a2a' }],
  ['홀로그램', { gradient: 'holo', effect: 'lift', outline: true, outlineColor: '#ffffff', effectColor: '#222244' }],
  ['레인보우', { gradient: 'rainbow', effect: '3d', outline: true, outlineColor: '#1a1a1a', effectColor: '#1a1a1a' }],
];

// 명도 조절 (SportsProLanding 과 동일 로직 — 기본 그라데이션 색감 일치 보장)
export const shade = (hex, amt) => {
  try {
    const n = parseInt(String(hex).slice(1), 16);
    let r = (n >> 16) + amt, g = ((n >> 8) & 0xff) + amt, b = (n & 0xff) + amt;
    r = Math.max(0, Math.min(255, r)); g = Math.max(0, Math.min(255, g)); b = Math.max(0, Math.min(255, b));
    return `#${((r << 16) | (g << 8) | b).toString(16).padStart(6, '0')}`;
  } catch { return hex; }
};

// 텍스트 스타일 객체 → MUI sx
export function buildTextSx(st, ctx) {
  st = st || {};
  const primary = (ctx && ctx.primary) || '#c9a96e';
  const defFont = (ctx && ctx.defFont) || 'sans';
  const defGrad = (ctx && ctx.defGrad) || 'theme';
  const gLight = shade(primary, 40), gDark = shade(primary, -40);
  const mid = st.color || primary;
  const gradient = st.gradient || defGrad;
  let bg = null, solid = null;
  if (gradient === 'theme' || gradient === 'custom') bg = `linear-gradient(180deg, ${st.c1 || gLight} 0%, ${mid} 50%, ${st.c2 || gDark} 100%)`;
  else if (gradient === 'white') solid = '#ffffff';
  else if (gradient === 'solid') solid = mid;
  else bg = TGRAD[gradient] || null;
  if (!bg && !solid) solid = mid;
  const glowy = st.effect === 'neon' || st.effect === 'glow';
  const sh = st.effectColor || (glowy ? mid : '#0a1326');
  const filt = ttexFilter(st.effect, sh);
  return {
    fontFamily: TEXT_FONTS[st.font] || TEXT_FONTS[defFont],
    ...(st.weight ? { fontWeight: Number(st.weight) } : {}),
    ...(st.spacing !== '' && st.spacing != null ? { letterSpacing: `${Number(st.spacing)}px` } : {}),
    ...(bg
      ? { background: bg, WebkitBackgroundClip: 'text', backgroundClip: 'text', WebkitTextFillColor: 'transparent', color: 'transparent' }
      : { color: solid }),
    ...(st.outline ? { WebkitTextStroke: `${st.outlineWidth || 1}px ${st.outlineColor || '#0a1326'}`, paintOrder: 'stroke fill' } : {}),
    ...(filt ? { filter: filt } : {}),
  };
}

// 봇 랜딩에서 사용 중인 글꼴 → 동적 Google Fonts 링크 (선택한 것만 로드)
export const usedFontLink = (l) => {
  const keys = [l && l.brandStyle && l.brandStyle.font, l && l.headStyle && l.headStyle.font,
    l && l.subStyle && l.subStyle.font, l && l.head_font].filter((k) => k && GF_FAMILIES[k]);
  if (!keys.length) return null;
  const fams = [...new Set(keys.map((k) => GF_FAMILIES[k]))].map((f) => `family=${f}`).join('&');
  return `https://fonts.googleapis.com/css2?${fams}&display=swap`;
};
